import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-8 col-sm-8 col-lg-8 offset-sm-2 offset-lg-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold mt-8 mb-7 ml-xs-7" }, "Agenda tu cita", -1)
const _hoisted_4 = { class: "card mb-15" }
const _hoisted_5 = { class: "card-header bg-dark-site" }
const _hoisted_6 = { class: "row align-items-center" }
const _hoisted_7 = { class: "col-lg-12 text-end text-lg-start" }
const _hoisted_8 = { class: "fs-2 fw-bold" }
const _hoisted_9 = { class: "card-body rounded-bottom bg-gray-site" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold" }, "Tipo de revisión"),
    /*#__PURE__*/_createElementVNode("p", { class: "fs-base mb-10" }, " Puedes visitarnos o nosotros podemos ir hasta la puerta de tu hogar ")
  ])
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-4 col-12 offset-md-1 outline-gray-lighten rounded text-center pb-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mt-20 mb-10" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-home fs-5tx text-white" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold mb-8" }, "Cita a domicilio", -1)
const _hoisted_15 = {
  key: 0,
  class: "fs-base text-white"
}
const _hoisted_16 = {
  key: 1,
  class: "not-available"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "isax-info-circle text-blue" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 d-none d-md-block d-lg-block" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "border-right-gray-lighten mt-10 pb-20",
    style: {"min-height":"220px"}
  })
], -1)
const _hoisted_19 = { class: "col-md-4 col-12 offset-md-1 outline-gray-lighten rounded text-center pb-5 mt-10 mt-sm-10 mt-xs-10 mt-md-0 mt-lg-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "mt-20 mb-10" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-building fs-5tx text-white" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold mb-8" }, "Cita a agencia", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "fs-base text-white" }, " Visita alguna de nuestras sucursales para revisar tu vehículo ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.vehicle.brand) + " | " + _toDisplayString(_ctx.vehicle.model) + " | " + _toDisplayString(_ctx.vehicle.version) + " | " + _toDisplayString(_ctx.vehicle.year), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: { path: '/seleccionar-cita/en-domicilio'},
                disabled: !_ctx.extra_data.has_appraiser,
                style: _normalizeStyle(!_ctx.extra_data.has_appraiser ? 'pointer-events:none;': '' ),
                event: _ctx.extra_data.has_appraiser ? 'click' : ''
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14,
                  (_ctx.extra_data.has_appraiser)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Nosotros vamos hasta tu domicilio para revisar tu vehículo "))
                    : _createCommentVNode("", true),
                  (!_ctx.extra_data.has_appraiser)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(" No disponible por el momento ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled", "style", "event"])
            ]),
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_router_link, {
                to: { path: '/cita-en-agencia' },
                disabled: !_ctx.extra_data.has_agency,
                event: _ctx.extra_data.has_agency ? 'click' : ''
              }, {
                default: _withCtx(() => [
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["disabled", "event"])
            ])
          ])
        ])
      ])
    ])
  ]))
}